
<script setup>
const props = defineProps({
    wrapperClass: {
        type: String,
    },
    title: {
        type: String,
    },
    subtitle: {
        type: String,
    },
    imgLink: {
        type: String,
        default: 'shape_14.png'
    }
})
</script>

<style>

</style>

<template>
    <div class="text-center px-[50px] max-w-[554px]" :class="wrapperClass">
        <img :src="Image(imgLink)" alt="empty heading image" class="w-[111px] h-[108px] m-auto mb-5">
        <div class="text-[#101828]  text-2xl font-semibold leading-8 mb-1.5">{{ props.title }}
        </div>
        <div class="text-[#667085] text-base font-normal leading-[22px]">{{ props.subtitle }}</div>
    </div>
</template>
